export const CREATE_CHANNEL_CONTRACT_DIALOG_SHOW = 'CREATE_CHANNEL_CONTRACT_DIALOG_SHOW';
export const CREATE_CHANNEL_CONTRACT_DIALOG_HIDE = 'CREATE_CHANNEL_CONTRACT_DIALOG_HIDE';

export const FETCH_CHANNEL_CONTRACT_AVAILABILITY_SUCCESS = 'FETCH_CHANNEL_CONTRACT_AVAILABILITY_SUCCESS';
export const FETCH_CHANNEL_CONTRACT_AVAILABILITY_IN_PROGRESS = 'FETCH_CHANNEL_CONTRACT_AVAILABILITY_IN_PROGRESS';
export const FETCH_CHANNEL_CONTRACT_AVAILABILITY_ERROR = 'FETCH_CHANNEL_CONTRACT_AVAILABILITY_ERROR';

export const CHANNEL_CONTRACT_DISPLAY_NAME_SET = 'CHANNEL_CONTRACT_DISPLAY_NAME_SET';
export const CHANNEL_CONTRACT_USER_NAME_SET = 'CHANNEL_CONTRACT_USER_NAME_SET';
export const CHANNEL_CONTRACT_USER_NAME_STATUS_SET = 'CHANNEL_CONTRACT_USER_NAME_STATUS_SET';

export const FETCH_CHANNEL_CONTRACT_SUCCESS = 'FETCH_CHANNEL_CONTRACT_SUCCESS';
export const FETCH_CHANNEL_CONTRACT_IN_PROGRESS = 'FETCH_CHANNEL_CONTRACT_IN_PROGRESS';
export const FETCH_CHANNEL_CONTRACT_ERROR = 'FETCH_CHANNEL_CONTRACT_ERROR';

export const FETCH_CHANNEL_CONTRACT_INFO_SUCCESS = 'FETCH_CHANNEL_CONTRACT_INFO_SUCCESS';
export const FETCH_CHANNEL_CONTRACT_INFO_ERROR = 'FETCH_CHANNEL_CONTRACT_INFO_ERROR';
export const FETCH_CHANNEL_CONTRACT_INFO_IN_PROGRESS = 'FETCH_CHANNEL_CONTRACT_INFO_IN_PROGRESS';

export const CHANNEL_CONTRACT_CHANGE_DIALOG_SHOW = 'CHANNEL_CONTRACT_CHANGE_DIALOG_SHOW';
export const CHANNEL_CONTRACT_CHANGE_DIALOG_HIDE = 'CHANNEL_CONTRACT_CHANGE_DIALOG_HIDE';

export const CHANNEL_CONTRACT_SETTINGS_TAB_SET = 'CHANNEL_CONTRACT_SETTINGS_TAB_SET';

export const SETTINGS_CHANNEL_CONTRACT_NAME_SET = 'SETTINGS_CHANNEL_CONTRACT_NAME_SET';
export const SETTINGS_CHANNEL_CONTRACT_DESCRIPTION_SET = 'SETTINGS_CHANNEL_CONTRACT_DESCRIPTION_SET';
export const SETTINGS_CHANNEL_CONTRACT_ADDRESS_SET = 'SETTINGS_CHANNEL_CONTRACT_ADDRESS_SET';
export const SETTINGS_CHANNEL_CONTRACT_ALLOW_PUBLISHERS_SET = 'SETTINGS_CHANNEL_CONTRACT_ALLOW_PUBLISHERS_SET';
export const CHANNEL_CONTRACT_COLLABORATION_STATUS_SET = 'CHANNEL_CONTRACT_COLLABORATION_STATUS_SET';
export const CHANNEL_CONTRACT_COLLABORATION_VALUE_SET = 'CHANNEL_CONTRACT_COLLABORATION_VALUE_SET';
export const ADD_NEW_COLLABORATORS = 'ADD_NEW_COLLABORATORS';

export const REMOVE_COLLABORATORS_DIALOG_SHOW = 'REMOVE_COLLABORATORS_DIALOG_SHOW';
export const REMOVE_COLLABORATORS_DIALOG_HIDE = 'REMOVE_COLLABORATORS_DIALOG_HIDE';

export const SETTINGS_CHANNEL_CONTRACT_IMAGE_SET = 'SETTINGS_CHANNEL_IMAGE_SET';
export const SETTINGS_CHANNEL_CONTRACT_BANNER_SET = 'SETTINGS_CHANNEL_BANNER_SET';
export const CHANNEL_CONTRACT_USERNAME_SETTINGS_SET = 'CHANNEL_CONTRACT_USERNAME_SETTINGS_SET';

export const CHANNEL_CONTRACT_SAVE_BUTTON_ENABLE_SET = 'CHANNEL_CONTRACT_SAVE_BUTTON_ENABLE_SET';

export const FETCH_CHANNEL_ASSETS_SUCCESS = 'FETCH_CHANNEL_ASSETS_SUCCESS';
export const FETCH_CHANNEL_ASSETS_IN_PROGRESS = 'FETCH_CHANNEL_ASSETS_IN_PROGRESS';
export const FETCH_CHANNEL_ASSETS_ERROR = 'FETCH_CHANNEL_ASSETS_ERROR';

export const CHANNEL_ASSETS_TAB_SET = 'CHANNEL_ASSETS_TAB_SET';

export const CHANNEL_CONTRACT_ADDRESS_FETCH_IN_PROGRESS = 'CHANNEL_CONTRACT_ADDRESS_FETCH_IN_PROGRESS';
export const CHANNEL_CONTRACT_ADDRESS_FETCH_SUCCESS = 'CHANNEL_CONTRACT_ADDRESS_FETCH_SUCCESS';
export const CHANNEL_CONTRACT_ADDRESS_FETCH_ERROR = 'CHANNEL_CONTRACT_ADDRESS_FETCH_ERROR';

export const FETCH_CHANNEL_CONTRACT_IV_SUCCESS = 'FETCH_CHANNEL_CONTRACT_IV_SUCCESS';
export const FETCH_CHANNEL_CONTRACT_IV_IN_PROGRESS = 'FETCH_CHANNEL_CONTRACT_IV_IN_PROGRESS';
export const FETCH_CHANNEL_CONTRACT_IV_ERROR = 'FETCH_CHANNEL_CONTRACT_IV_ERROR';

export const FETCH_CHANNEL_CONTRACT_VOD_SUCCESS = 'FETCH_CHANNEL_CONTRACT_VOD_SUCCESS';
export const FETCH_CHANNEL_CONTRACT_VOD_IN_PROGRESS = 'FETCH_CHANNEL_CONTRACT_VOD_IN_PROGRESS';
export const FETCH_CHANNEL_CONTRACT_VOD_ERROR = 'FETCH_CHANNEL_CONTRACT_VOD_ERROR';

export const FETCH_CONTRACT_INTERACTIVE_VIDEOS_SUCCESS = 'FETCH_CONTRACT_INTERACTIVE_VIDEOS_SUCCESS';
export const FETCH_CONTRACT_INTERACTIVE_VIDEOS_IN_PROGRESS = 'FETCH_CONTRACT_INTERACTIVE_VIDEOS_IN_PROGRESS';
export const FETCH_CONTRACT_INTERACTIVE_VIDEOS_ERROR = 'FETCH_CONTRACT_INTERACTIVE_VIDEOS_ERROR';

export const FETCH_CONTRACT_VIDEO_MINTS_SUCCESS = 'FETCH_CONTRACT_VIDEO_MINTS_SUCCESS';
export const FETCH_CONTRACT_VIDEO_MINTS_IN_PROGRESS = 'FETCH_CONTRACT_VIDEO_MINTS_IN_PROGRESS';
export const FETCH_CONTRACT_VIDEO_MINTS_ERROR = 'FETCH_CONTRACT_VIDEO_MINTS_ERROR';

export const FETCH_CONTRACT_GATED_IV_SUCCESS = 'FETCH_CONTRACT_GATED_IV_SUCCESS';
export const FETCH_CONTRACT_GATED_IV_IN_PROGRESS = 'FETCH_CONTRACT_GATED_IV_IN_PROGRESS';
export const FETCH_CONTRACT_GATED_IV_ERROR = 'FETCH_CONTRACT_GATED_IV_ERROR';

export const FETCH_CONTRACT_VIDEO_DROPS_SUCCESS = 'FETCH_CONTRACT_VIDEO_DROPS_SUCCESS';
export const FETCH_CONTRACT_VIDEO_DROPS_IN_PROGRESS = 'FETCH_CONTRACT_VIDEO_DROPS_IN_PROGRESS';
export const FETCH_CONTRACT_VIDEO_DROPS_ERROR = 'FETCH_CONTRACT_VIDEO_DROPS_ERROR';

export const FETCH_CONTRACT_UPCOMING_IV_SUCCESS = 'FETCH_CONTRACT_UPCOMING_IV_SUCCESS';
export const FETCH_CONTRACT_UPCOMING_IV_IN_PROGRESS = 'FETCH_CONTRACT_UPCOMING_IV_IN_PROGRESS';
export const FETCH_CONTRACT_UPCOMING_IV_ERROR = 'FETCH_CONTRACT_UPCOMING_IV_ERROR';

export const IS_V2_CHANNEL_PRESENT = 'IS_V2_CHANNEL_PRESENT';

export const SET_CHANNEL_EMPTY = 'SET_CHANNEL_EMPTY';

export const CHANNEL_PAGE_TAB_VALUE_SET = 'CHANNEL_PAGE_TAB_VALUE_SET';
export const CHANNEL_PAGE_SUB_TAB_VALUE_SET = 'CHANNEL_PAGE_SUB_TAB_VALUE_SET';

export const SET_VIDEOS_LIST_EMPTY = 'SET_VIDEOS_LIST_EMPTY';

export const FETCH_CHANNEL_LIVE_STREAMS_SUCCESS = 'FETCH_CHANNEL_LIVE_STREAMS_SUCCESS';
export const FETCH_CHANNEL_LIVE_STREAMS_IN_PROGRESS = 'FETCH_CHANNEL_LIVE_STREAMS_IN_PROGRESS';
export const FETCH_CHANNEL_LIVE_STREAMS_ERROR = 'FETCH_CHANNEL_LIVE_STREAMS_ERROR';

export const FETCH_CHANNEL_VIDEOS_STATS_SUCCESS = 'FETCH_CHANNEL_VIDEOS_STATS_SUCCESS';
export const FETCH_CHANNEL_VIDEOS_STATS_IN_PROGRESS = 'FETCH_CHANNEL_VIDEOS_STATS_IN_PROGRESS';
export const FETCH_CHANNEL_VIDEOS_STATS_ERROR = 'FETCH_CHANNEL_VIDEOS_STATS_ERROR';

export const SET_CHANNEL_IV_SEARCH = 'SET_CHANNEL_IV_SEARCH';

export const DISCARD_CHANGES_DIALOG_HIDE = 'DISCARD_CHANGES_DIALOG_HIDE';
export const DISCARD_CHANGES_DIALOG_SHOW = 'DISCARD_CHANGES_DIALOG_SHOW';
